<template>
  <div>
    <van-cell class="ry-form__currency" v-if="isNormalStyle">
      <template slot="title">
        <span class="title">{{current.title}}</span>
        <span style="color: red" v-if="!isRead && current.required">*</span>
      </template>
      <template slot="label">

        <template v-if="current.fieldHint">
          <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
          <div
            v-else
            class="ql-editor"
            v-html="current.fieldHint">
          </div>
        </template>
        <div
          v-if="isRead">
          {{current.currencyType === CURRENCY_TYPE__DOLLAR? '$': '￥'}} {{showValue}}{{current.showUnit}}
        </div>
        <van-field
          class="ry-form__currency-input"
          v-if="!isRead"
          type="number"
          :readonly="isReadOnly"
          @change="valueChange"
          @blur="inputBlur"
          @focus="inputFocus"
          v-model="currentRow[dataId]"
          :placeholder="current.fieldDes"
          :error-message="errorMessage">
          <i slot="left-icon">
            {{current.currencyType === CURRENCY_TYPE__DOLLAR? '$': '￥'}}
          </i>
          <div slot="extra" style="display: flex; align-items: center;">{{current.showUnit}}</div>
        </van-field>
        <span v-if="isShowUpper">{{upper}}</span>
      </template>
    </van-cell>

    <div v-else class="ry-form-item-compact ry-form__currency-compact">


      <van-field
        v-if="isRead"
        :label="current.title"
        :required="Boolean(!isRead && current.required)">
        <template #input>
          <div>
            {{current.currencyType === CURRENCY_TYPE__DOLLAR? '$': '￥'}} {{showValue}}{{current.showUnit}}
          </div>
        </template>
      </van-field>

      <van-field
        v-if="!isRead"
        type="number"
        :label-class="{'readonly-field-label': isReadOnly}"
        :readonly="isReadOnly"
        @change="valueChange"
        @blur="inputBlur"
        @focus="inputFocus"
        v-model="currentRow[dataId]"
        :placeholder="current.fieldDes || isReadOnly ? '暂无内容' : '请填写内容'"
        :required="Boolean(!isRead && current.required)">
        <template slot="label">
          <span>
            <span class="title">{{current.title}}</span>
            ({{current.currencyType === CURRENCY_TYPE__DOLLAR? '$': '￥'}})
          </span>
        </template>

        <div slot="extra" style="display: flex; align-items: center;">{{current.showUnit}}</div>
      </van-field>
      <span v-if="isShowUpper" class="upper">{{upper}}</span>
    </div>
  </div>

</template>
<script>
  import { current } from './mixin'
  import {CURRENCY_TYPE__DOLLAR, CURRENCY_TYPE__RMB, DEFAULT_VALUE__CUSTOM} from '../../types'
  import Currency from "../../instances/Currency";
  import {formatNum} from "../../../../assets/js/Untis";
  export default {
    mixins: [current],
    data () {
      return {
        CURRENCY_TYPE__DOLLAR,
        isError: false
      }
    },
    computed: {
      isShowUpper() {
        return this.current.showUpper && this.current.currencyType === CURRENCY_TYPE__RMB
      },
      errorMessage() {
        return this.isError ? this.current.requiredShowText : ''
      },
      upper() {
        let val = 0
        if (this.currentRow[this.current.dataId]) {
          val = this.currentRow[this.current.dataId]
        } else if (this.current.defaultValue.defaultType === DEFAULT_VALUE__CUSTOM) {
          val = this.defaultValue.customValue
        }
        return Currency.convertCurrency(val)
      },
      showValue() {
        if (this.current.tp === 'YES') {
          return formatNum(this.currentRow[this.dataId])
        } else {
          return this.currentRow[this.dataId]
        }
      }
    },
    methods: {
      inputBlur () {
        if (!this.currentRow[this.current.dataId] || !Number(this.currentRow[this.current.dataId])) {
          this.currentRow[this.current.dataId] = 0
        } else {
          this.currentRow[this.current.dataId] = Number(this.currentRow[this.current.dataId])
        }

        this.isError = this.current.checkMissValue && this.isShowRequiredText
      },
      // Input 获得焦点时触发
      inputFocus() {
        if (!this.currentRow[this.current.dataId] || !Number(this.currentRow[this.current.dataId])) {
          this.currentRow[this.current.dataId] = null
        }
      },
      valueChange() {
        if (!this.currentRow[this.current.dataId]) {
          this.currentRow[this.current.dataId] = null
        } else {
          this.currentRow[this.current.dataId] = Number(this.currentRow[this.current.dataId])
        }
        this.controlChange()
      }
    },
    components: {},
    watch: {}
  }
</script>

<style lang="less">
  .ry-form__currency-compact {

    .upper {
      margin-left: 124px;
      font-size: 12px;
      color: #323233;
      display: block;
      padding-bottom: 5px;
    }
  }
</style>